export const INPUT = {
  keyboard: "keyboard",
};
